export const STAFF_REF_STORAGE_KEY = 'ldsurvey:staffRef';

export const STAFF_SESSION_STORAGE_KEY = 'ldsurveyStaff';
